/* eslint-disable*/
import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import EventRegistration from '../../pages/EventRegistration/EventRegistration';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { useEventState } from '../../stores/eventStore';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';

const EventRegistrations = (props) => {
    const userInfo = useState(null);
    const showCancel = useState(false);
    const eventState = useEventState();
    const [eventID, setEventID] = React.useState(null);
    const [asAdmin, setAsAdmin] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const showSaveAsDraftBtn = useState(false);
    const loading = useState(false);
    const [requestStatus, setRequestStatus] = React.useState('');
    const history = useHistory();
    let params = useParams();
    const [participantList, setParticipantList] = React.useState(null);

    useEffect(() => {
        if (eventState && eventState.eventDetail.get() != null) {
            const userInfo = Helper.getStorage('userInfo');
            const gAgentInfo = Helper.getSessionStorage('agentUser');

            if (!(Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo))) {
                const permissions = eventState.permissions.attach(Downgraded).get();
                if (permissions && permissions.length > 0) {
                    setModPermission(Helper.getModuleAccessPermission(permissions, 'COMBINEREGISTRATION'));
                }
            }
            else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION)
            }
        }
        let showSaveDraft = false;
        const allModules = eventState.moduleState.get() !== null ? eventState.moduleState.get().find(i => i.requestStatus === 'To Do') : null;
        const isInTodo = allModules ? allModules.modules.some(m => m.module === 'CombineRegistration') : false;
        //show save as draft button for end User and Agent screen
        if (isInTodo && !Helper.isAdminUser(userInfo) && !Helper.isEventStaff(userInfo) && !Helper.isEventAdmin(userInfo)) {
            // console.log("requestStatus",requestStatus);
            // if(requestStatus !== '0' || requestStatus !== "" || requestStatus !== undefined){
            //     showSaveDraft = false;    
            // }else{
                showSaveDraft = true;
            // } 
        }
        else if (isInTodo && gAgentInfo &&
            !(Helper.isAdminUser(gAgentInfo) ||
                (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo))) &&
            !(gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))
        ) {
            showSaveDraft = true;
        }
        showSaveAsDraftBtn.set(showSaveDraft);
    }, [eventState])

    useEffect(() => {

        const fetchdata = async () => {
            if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
                const gUserInfo = Helper.getStorage('userInfo');
                const gEventInfo = Helper.getStorage('eventInfo');
                setEventID(gEventInfo.eventID);
                if (
                    history.location &&
                    typeof history.location.state !== 'undefined'
                ) {
                    if (history.location.state.adminUser) {
                        setAsAdmin(history.location.state.adminUser);
                    }
                    setParticipantList(history.location.state.participantList);
                }
                const gAgentInfo = Helper.getSessionStorage('agentUser');
                const agentConnection = Helper.getSessionStorage('agentConnections');
                let tags = await getUserTags(gEventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : gUserInfo.userID)
                if (params && params.registrationID) {
                    ApiHelper.get(APIURLConstants.GET_EVENT_REGISTRATION(params.registrationID)).then(
                        (res) => {
                            if (res.data) {
                                userInfo.set(res.data);
                            }
                        }
                    )
                        .catch((err) => {
                            //... Check if user's session has expired
                            if (err.response && err.response.status === 401) {
                                console.log(err);
                            }

                        });
                } else if (gEventInfo !== null) {
                    const gAgentInfo = Helper.getSessionStorage('agentUser');
                    const agentConnection = Helper.getSessionStorage('agentConnections');
                    if (gAgentInfo &&
                        !(Helper.isAdminUser(gAgentInfo) ||
                            (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo))) &&
                        !(gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))
                    ) {
                        getRegistrationInfo(tags, gEventInfo, gAgentInfo, agentConnection, gUserInfo);
                    }

                    else if (
                        !(Helper.isAdminUser(gUserInfo) ||
                            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo))) &&
                        !(gUserInfo.roles && Helper.isEventStaff(gUserInfo))
                    ) {

                        getRegistrationInfo(tags, gEventInfo, gAgentInfo, agentConnection, gUserInfo);
                    }
                }
                if (
                    Helper.isAdminUser(gUserInfo) ||
                    (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
                ) {
                    showCancel.set(true);
                }
            }
        }
        fetchdata();
    }, [modPermission]);

    const getRegistrationInfo = (tags, gEventInfo, gAgentInfo, agentConnection, gUserInfo) => {
        ApiHelper.get(APIURLConstants.GET_EVENT_REGISTRATION_INFO(gEventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : gUserInfo.userID)).then(
            (res) => {
                if (res.data) {
                    let users = res.data;
                    // console.log("users",users);
                    setRequestStatus(users.requestStatus)
                    users["userTags"] = tags.UserTags
                    userInfo.set(users);
                }
                else {
                    ApiHelper.get(APIURLConstants.GET_USER(gAgentInfo ? gAgentInfo.userID : gUserInfo.userID)).then(
                        (res) => {

                            if (res.data) {
                                let users = res.data;
                                console.log(users)
                                users["userTags"] = tags.UserTags
                                userInfo.set(users);
                            }
                        }
                    ).catch((err) => {
                        //... Check if user's session has expired
                        if (err.response && err.response.status === 401) {
                            console.log(err);
                        }
                    });
                }
            }
        ).catch((err) => {
            //... Check if user's session has expired
            if (err.response && err.response.status === 401) {
                console.log(err);
            }

        });
    }
    const getUserTags = (eventid, userid) => {
        return ApiHelper.get(APIURLConstants.GET_USER_TAGS(eventid, userid))
            .then(res => {
                return res.data
            })
    }
    const getAllRegistrationInfo = () => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const gUserInfo = Helper.getStorage('userInfo');
            const gEventInfo = Helper.getStorage('eventInfo');
            setEventID(gEventInfo.eventID);
            if (
                history.location &&
                typeof history.location.state !== 'undefined'
            ) {
                if (history.location.state.adminUser) {
                    setAsAdmin(history.location.state.adminUser);
                }
                setParticipantList(history.location.state.participantList);
            }
            if (params && params.registrationID) {
                ApiHelper.get(APIURLConstants.GET_EVENT_ALLSTAR_REGISTRATION(params.registrationID)).then(
                    (res) => {
                        if (res.data) {
                            userInfo.set(res.data);
                            loading.set(false)
                        }
                    }
                )
                    .catch((err) => {
                        loading.set(false)
                        if (err.response && err.response.status === 401) {
                            console.log(err);
                        }

                    });
            }
            else if (gEventInfo !== null) {
                const gAgentInfo = Helper.getSessionStorage('agentUser');
                const agentConnection = Helper.getSessionStorage('agentConnections');
                if (gAgentInfo &&
                    !(Helper.isAdminUser(gAgentInfo) ||
                        (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo))) &&
                    !(gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))
                ) {

                    ApiHelper.get(APIURLConstants.GET_EVENT_ALLSTAR_REGISTRATION_INFO(gEventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : gUserInfo.userID)).then(
                        (res) => {
                            loading.set(false)
                            if (res.data) {
                                let users = res.data;
                                userInfo.set(users);
                            }
                            else {
                                userInfo.set()
                            }
                        }
                    ).catch((err) => {
                        loading.set(false)
                        if (err.response && err.response.status === 401) {
                            console.log(err);
                        }

                    });
                } else if (
                    !(Helper.isAdminUser(gUserInfo) ||
                        (gUserInfo.roles && Helper.isEventAdmin(gUserInfo))) &&
                    !(gUserInfo.roles && Helper.isEventStaff(gUserInfo))
                ) {
                    const gAgentInfo = Helper.getSessionStorage('agentUser');
                    const agentConnection = Helper.getSessionStorage('agentConnections');
                    ApiHelper.get(APIURLConstants.GET_EVENT_ALLSTAR_REGISTRATION_INFO(gEventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : gUserInfo.userID)).then(
                        (res) => {
                            loading.set(false)
                            if (res.data) {
                                let users = res.data;
                                userInfo.set(users);
                            }
                            else {
                                userInfo.set()
                            }
                        }
                    ).catch((err) => {
                        loading.set(false)
                        if (err.response && err.response.status === 401) {
                            console.log(err);
                        }

                    });
                }
            }
            if (
                Helper.isAdminUser(gUserInfo) ||
                (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
            ) {
                showCancel.set(true);
            }
        }
    }

    const handleCancel = () => {
        props.history.push(generatePath(RouteConstants.EVENT_REGISTRATION_LIST, { eventID: eventID }));
    }
    return (
        <>
            {modPermission && modPermission == NO_ACCESS_PERMISSION ?
                <UnauthorizedUI showLogout={false} /> :
                <EventRegistration
                    data={userInfo.attach(Downgraded).get()}
                    loading={loading}
                    participantList={participantList}
                    handleCancel={handleCancel}
                    showCancel={showCancel.get()}
                    {...props}
                    asAdmin={asAdmin}
                    showSaveAsDraftBtn={showSaveAsDraftBtn.get()}
                    eventStateDetail={eventState.attach(Downgraded).get()}
                    modPermission={modPermission}
                    getAllRegistrationInfo={getAllRegistrationInfo}
                />
            }
        </>
    )
}

export default {
    routeProps: {
        path: [RouteConstants.EVENT_REGISTER_CREATE, RouteConstants.EVENT_EDIT_REGISTER],
        component: EventRegistrations,
    },
    name: 'EventRegistration',
};
